/*
 * Lifecycle stepper: pure model, no React. The icon and tones of a step by its state (table-driven).
 */
import type { Step } from '../buildHelpers';

type State = Step['state'];

const ICON: Record<State, string> = { done: 'check_circle', active: 'radio_button_checked', todo: 'radio_button_unchecked', failed: 'cancel', skipped: 'remove_circle' };
const COLOR: Record<State, string> = { done: 'text-succeeded', active: 'text-running', todo: 'text-subtle', failed: 'text-failed', skipped: 'text-subtle' };
/** The connector fills up to the active stage: green behind it, a lighter run tone at it, grey after. */
const CONNECTOR: Record<State, string> = { done: 'bg-succeeded/60', active: 'bg-running/40', todo: 'bg-border', failed: 'bg-border', skipped: 'bg-border' };
const LABEL: Record<State, string> = { done: 'text-foreground', active: 'text-running', todo: 'text-subtle', failed: 'text-failed', skipped: 'text-subtle' };

export const stepIcon = (state: State): string => ICON[state];
export const stepColor = (state: State): string => COLOR[state];
export const connectorClass = (state: State): string => CONNECTOR[state];
export const labelClass = (state: State): string => LABEL[state];

/** Done and active steps draw a filled icon. */
export const stepFilled = (state: State): boolean => state === 'active' || state === 'done';

const PROGRESS: Record<State, string> = { done: 'bg-succeeded', active: 'bg-running', todo: 'bg-running', failed: 'bg-failed', skipped: 'bg-border' };

/** The phone stepper's progress bar takes the tone of the current step: green when done, red when it failed. */
export const progressTone = (state: State): string => PROGRESS[state];
